import { render } from "./OpenQuestion.vue?vue&type=template&id=998823fc&scoped=true"
import script from "./OpenQuestion.vue?vue&type=script&lang=js"
export * from "./OpenQuestion.vue?vue&type=script&lang=js"

import "./OpenQuestion.vue?vue&type=style&index=0&id=998823fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998823fc"]])

export default __exports__